import React from 'react'
import {
  Create,
  SimpleForm,
  TextInput,
  useTranslate
} from 'react-admin'
import { CardCommon } from 'src/components/uiElements'
import { Grid } from '@mui/material'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'

export const ContactCreate = (props) => {
  const translate = useTranslate()
  return (
    <Create {...props} redirect='list' actions={null}>
      <CardCommon title={translate('ra.entity.contact')} actions={null}>
        <SimpleForm>
          <Grid container spacing={3}>
            <EditInputsWrap label={translate('ra.field.name')}>
              <TextInput required label={false} fullWidth source='name' />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.surname')}>
              <TextInput label={false} fullWidth source='surname' />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.email')}>
              <TextInput label={false} fullWidth source='email' />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.document_type')}>
              <TextInput label={false} fullWidth source='document_type' />
              </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.document_number')}>
              <TextInput label={false} fullWidth source='document_number' />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.birthday')}>
              <TextInput label={false} fullWidth source='birthday' />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.phone_number')}>
              <TextInput label={false} fullWidth source='phone_number' />
            </EditInputsWrap>
          </Grid>
        </SimpleForm>
      </CardCommon>
    </Create>
  )
}
